export default "__VITE_ASSET__CRpXMcBy__"